import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fr from 'vuetify/lib/locale/fr';
import en from 'vuetify/lib/locale/en';
import de from 'vuetify/lib/locale/de';
import es from 'vuetify/lib/locale/es';
import nl from 'vuetify/lib/locale/nl';

Vue.use(Vuetify);
const config = window.configVuetify ? window.configVuetify : {};
config.lang = {
  locales: { fr, en, de, es, nl },
  current: document.documentElement.lang || 'fr',
};

export default new Vuetify(config);
